import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResourceType, RiskAdjustment, RiskEvidence } from '@arcadia/workflow-shared-risk';
import { map } from 'rxjs/operators';

import { IRiskDocument, SubjectResourceType } from '@assess/shared/data-mart';

import { DataMartApiConfiguration } from '../data-mart-api-configuration';

@Injectable({ providedIn: 'root' })
export class EvidenceService {
  constructor(
    private readonly http: HttpClient,
    private readonly config: DataMartApiConfiguration
  ) {}

  getRiskEvidence(personId: string, riskId: string) {
    const url = `${this.config.crudUrl}/objects/risk/${personId}`;

    return this.http.get<IRiskDocument>(url).pipe(
      map((riskDocument) => {
        const risk = riskDocument.risk?.filter((r) => r['@id'] === riskId)[0];

        return risk?.evidence
          ?.filter((evidence) => evidence.source.evidenceType?.toLowerCase() !== 'claim')
          .sort(this.sortByDate);
      })
    );
  }

  getRiskEvidenceAndAdjustments(personId: string, riskId: string) {
    const url = `${this.config.crudUrl}/objects/risk/${personId}`;

    return this.http.get<IRiskDocument>(url).pipe(
      map((riskDocument) => {
        const risk = riskDocument.risk?.filter((r) => r['@id'] === riskId)[0];

        const evidences: RiskEvidence[] =
          risk?.evidence
            ?.filter((evidence) => evidence.source.evidenceType?.toLowerCase() !== 'claim')
            .map((evidence) => {
              return { ...evidence, '@type': ResourceType.RiskEvidence };
            }) || [];

        const adjustments: RiskAdjustment[] =
          risk?.riskAdjustment?.map((adj) => {
            return { ...adj, '@type': ResourceType.RiskAdjustment };
          }) || [];

        return [...evidences, ...adjustments].sort(this.sortByDate);
      })
    );
  }

  dateExtractor = (item: any) =>
    item['@type'] === SubjectResourceType.RiskEvidence ? item.date : item.alternateEvidence?.date;

  sortByDate = (left: RiskAdjustment | RiskEvidence, right: RiskAdjustment | RiskEvidence) => {
    const leftDate = this.dateExtractor(left);
    const rightDate = this.dateExtractor(right);
    if (leftDate && rightDate) {
      return new Date(rightDate).getTime() - new Date(leftDate).getTime();
    } else if (!leftDate && rightDate) {
      return 1;
    } else if (!rightDate && leftDate) {
      return -1;
    }

    return 0;
  };
}
